import basePath from "base_path";
import ActionTypes, {ProjectActionTypes} from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";
import {OrganisationId} from "common/types/organisation";
import {ProjectId, ProjectIssueOverrideTag} from "common/types/project";

export type IssueOverrideTagRemoveAction = {
  type: ProjectActionTypes["PROJECT_REMOVE_ISSUE_OVERRIDE_TAG"]["SUCCESS"];
  payload: ProjectIssueOverrideTag[];
};

export default function removeIssueOverrideProjectTag(requestor) {
  return createReduxPromiseAction(
    ActionTypes.PROJECT_REMOVE_ISSUE_OVERRIDE_TAG,
    (organisationId: OrganisationId, projectId: ProjectId, tagId: string) => {
      return requestor
        .delete(
          `${basePath}/organisation/${organisationId}/project/${projectId}/issue_override_tag/${tagId}`,
          {
            withCredentials: true,
          },
        )
        .then(response => {
          return response.data;
        });
    },
  );
}
